/// <reference path="../../app.definition.ts" />

import angular from "angular";
import _ from "lodash";
import { JavaApiAdapterService } from "@common/apiadapter/javaapi.service";
import { ICachingService } from "@common/service/caching.service";
import { RESET_FOLDER_FIELD } from "@common/model/constants";
export interface IFeedService {
    deleteFeed: Function;
    deleteIt: Function;
    updateFeedInLocalCache: Function;
    crSwitched: boolean;

    getCachedFeedIds: Function;
    getDocumentsByIds: Function;
    addOrUpdateCachedFeedIds: Function;
    addOrUpdateCachedFolderFeedIds: Function;
    addNewCachedFeedId: Function;
    addNewFeed: Function;
    addNewDocsFeed: Function;
    removeFailedDocsFeeds: Function;
    getPaginatedDocFeeds: Function;
    getPaginatedFolderFeeds: Function;
}

export class FeedService implements IFeedService {
    deleteFeed: Function;
    deleteIt: Function;
    updateFeedInLocalCache: Function;
    crSwitched: boolean;

    getCachedFeedIds: Function;
    getDocumentsByIds: Function;
    addOrUpdateCachedFeedIds: Function;
    addOrUpdateCachedFolderFeedIds: Function;
    addNewCachedFeedId: Function;
    addNewFeed: Function;
    addNewDocsFeed: Function;
    removeFailedDocsFeeds: Function;
    getPaginatedDocFeeds: Function;
    getPaginatedFolderFeeds: Function;

    static $inject = ["CacheService", "ApiAdapterService", "$q", "$rootScope", "CachingService", "BroadcastService"];

    constructor(private CacheService,
        private $_api: JavaApiAdapterService,
        private $q,
        private $rootScope,
        private $_caching: ICachingService,
        private BroadcastService) {
        this.crSwitched = false;
        if (!!CacheService.getCrSwitched()) {
            this.crSwitched = CacheService.getCrSwitched();
        }

        this.getPaginatedDocFeeds = (type, page, size, filter = null, sort = null): ng.IPromise<any> => {
            let deferred = this.$q.defer();
            this.$_caching.getPaginatedDocFeeds(page, size, filter, sort).then(data => {
                let docs = _.cloneDeep(data['posts']);
                this.$_caching.getDiscussionObjects(data.posts).then(res => {
                    data['posts'] = res;
                    if (page == 0 && this.getCachedFeedIds(type).length > 0) {
                        deferred.resolve(data);
                        return;
                    }
                    this.addOrUpdateCachedFeedIds(docs, type, false).then(() => deferred.resolve(data));
                })

            });
            return deferred.promise;
        }

        this.getPaginatedFolderFeeds = (page, size, filter, sortProp, folderId) => {
            let deferred = this.$q.defer();
            this.$_caching.getPaginatedDocFeeds(page, size, filter, sortProp).then(data => {
                let docs = _.cloneDeep(data['posts']);
                this.$_caching.getDiscussionObjects(data.posts).then(res => {
                    data['posts'] = res;
                    if (size === 1 || (page == 0 && this.$_caching.getCachedFolderFeedsById(folderId).length > 0)) {
                        deferred.resolve({
                            docs: data.posts,
                            totalElements: data.totalElements
                        });
                        return;
                    } else {
                        this.addOrUpdateCachedFolderFeedIds(docs, folderId, false).then(() => {
                            deferred.resolve({
                                docs: data.posts,
                                totalElements: data.totalElements
                            });
                        })
                    }
                })
            })
            return deferred.promise;
        }

        this.getCachedFeedIds = (type: string): any => {
            var data = $_caching.getCachedFeeds();
            if (data) {
                return data[type];
            } else {
                return [];
            }
        }

        this.getDocumentsByIds = (feeds: any[], type: string): any => {
            var deferred = this.$q.defer();
            let results = [];
            let ids = [];
            for (let doc of feeds) {
                ids.push(doc.id);
            }
            $_caching.getDocuments(ids, type).then(
                documents => {
                    //documents returned without specific ordering, match to order of ids
                    for (let id of ids) {
                        let doc = documents.find(d => id == d.id);
                        !!doc && results.push(doc);
                    }
                    deferred.resolve(results);
                }
            );
            return deferred.promise;
        }

        this.addOrUpdateCachedFeedIds = (docDetail: any[], type: string, updateCache: boolean) => {
            var deferred = this.$q.defer();
            var cachedFeeds = $_caching.getCachedFeeds();
            let localFeeds = this.getCachedFeedIds(type);
            let cpy = angular.copy(localFeeds);
            if (!updateCache) {
                localFeeds = localFeeds.concat(docDetail);
                cachedFeeds[type] = localFeeds;
                $_caching.saveCachedFeeds(cachedFeeds);
                deferred.resolve();
            } else {
                for (var i = 0; i < docDetail.length; i++) {
                    cpy = cpy.filter((feed) => feed.id != docDetail[i].id);
                }
                docDetail = docDetail.concat(cpy);
                cachedFeeds[type] = docDetail;
                $_caching.saveCachedFeeds(cachedFeeds);
                deferred.resolve();
            }

            return deferred.promise;
        }

        this.addOrUpdateCachedFolderFeedIds = (docDetail: any[], folderId: string, updateCache: boolean) => {
            var deferred = this.$q.defer();
            var cachedFeeds = this.$_caching.getCachedFolderFeeds();
            let localFeeds = this.$_caching.getCachedFolderFeedsById(folderId);
            let cpy = angular.copy(localFeeds);
            if (!updateCache) {
                localFeeds = localFeeds.concat(docDetail);
                cachedFeeds[folderId] = localFeeds;
                this.$_caching.saveCachedFolderFeeds(cachedFeeds);
                deferred.resolve();
            } else {
                if (this.$_caching.getForFolderReset(RESET_FOLDER_FIELD.SORT)) {
                    docDetail = [];
                } else {
                    for (var i = 0; i < docDetail.length; i++) {
                        cpy = cpy.filter((feed) => feed.id != docDetail[i].id);
                    }
                    docDetail = docDetail.concat(cpy);
                }
                cachedFeeds[folderId] = docDetail;
                this.$_caching.saveCachedFolderFeeds(cachedFeeds);
                deferred.resolve();
            }

            return deferred.promise;
        }

        //delete feeds from local cache
        this.deleteFeed = (id: string) => {
            var deferred = this.$q.defer();
            var cachedFeeds = $_caching.getCachedFeeds();
            this.deleteIt(id, "posts", cachedFeeds).then((s) => {
                this.deleteIt(id, "documents", cachedFeeds).then((s) => {
                    this.deleteIt(id, "discussions", cachedFeeds).then((s) => {
                        $_caching.deleteDocuments(id);
                        deferred.resolve('success');
                    });
                })
            });


            return deferred.promise;
        }

        // delete post from cache
        this.deleteIt = (id: string, type: string, data: any) => {
            var deferred = this.$q.defer();
            var localFeedData = this.getCachedFeedIds(type);
            for (var j = 0; j < localFeedData.length; j++) {
                if (localFeedData[j].id == id) {
                    localFeedData.splice(j, 1);
                    break;
                }
            }
            data[type] = localFeedData;
            $_caching.saveCachedFeeds(data);
            deferred.resolve();
            return deferred.promise;
        }

        this.removeFailedDocsFeeds = (): void => {
            let type = 'posts';
            var cachedFeeds = this.$_caching.getCachedFeeds();
            cachedFeeds[type] = this.getCachedFeedIds(type).filter(f => !f.failed);
            this.$_caching.saveCachedFeeds(cachedFeeds);
        }

        //This will be called from the push notification service
        this.updateFeedInLocalCache = (f: any, type: string, remove: boolean, updateCachedFeedIds: boolean) => {
            var deferred = this.$q.defer();
            if (f.length > 0) {
                if (!!remove && remove == true) {
                    for (var i = 0; i < f.length; i++) {
                        let feed = this.getCachedFeedIds(type).find(d => d.id == f[i].id);
                        if (!!feed) {
                            feed['failed'] = true;
                            feed['uploading'] = true;
                        }
                    }
                    $_caching.updateFailStatus(f).then((s) => {
                        deferred.resolve();
                    });
                } else {
                    for (var i = 0; i < f.length; i++) {
                        f[i]['uploading'] = false;
                        f[i]['failed'] = false;
                    }
                    if (!!updateCachedFeedIds) {
                        this.addOrUpdateCachedFeedIds(f, type, true).then((s) => {
                            deferred.resolve();
                        });
                    } else {
                        deferred.resolve();
                    }
                }
            }
            return deferred.promise;
        }


        this.addNewCachedFeedId = (docs: any[], type: string): any => {
            var deferred = this.$q.defer();
            this.addOrUpdateCachedFeedIds(docs, type, true).then((s) => {
                deferred.resolve();
            })
            return deferred.promise;
        }

        //This will be called when new doc or disc is created
        this.addNewFeed = (doc: any, type: string): any => {
            var deferred = this.$q.defer();
            this.addOrUpdateCachedFeedIds([doc], type, true).then((s) => {
                type = "posts";
                this.addOrUpdateCachedFeedIds([doc], type, true).then((s) => {
                    deferred.resolve();
                });
            });
            return deferred.promise;
        }

        //This will be called when new doc is created
        this.addNewDocsFeed = (doc: any[], type: string): any => {
            var deferred = this.$q.defer();

            this.addOrUpdateCachedFeedIds(doc, type).then((s) => {
                deferred.resolve();
            })

            return deferred.promise;
        }

        this.BroadcastService.registerCallBack('cr-switched', this.$rootScope.$id, (data) => {
            this.crSwitched = true;
            console.log(this);
            console.log(CacheService);
            console.log(this.CacheService);
            this.CacheService.setCrSwitched(true);
        });
        this.$rootScope.$on('$destroy', () => {
            this.BroadcastService.removeCallBack('cr-switched', this.$rootScope.$id);
        });
    }
}

angular.module('eCareVault.common.services')
    .service('FeedService', FeedService);